// eslint-disable-next-line complexity
function getNames(id, map , expression){
  if(id == null){
    return null;
  }
  return expression ? expression(map[id]): map[id]?.displayName || '?-?'
}

export default {
  isLoadedDictionary(state){
    return (name) => !!state.loaded[name]
  },
  getOrganizationName (state) {
    return (id)=> getNames(id, state.organizationsMap)
  },
  getBusinessGroupName (state) {
    return (id)=> getNames(id, state.businessGroupsMap);
  },
  getBillingInfoCalculationType(state) {
    return (id)=> getNames(id, state.billingInfosMap, (i) => i.calculationType );
  },
  billingInfos(state) {
    return state.billingInfos;
  },
  getPricingLevelGroupName (state) {
    return (id)=> getNames(id, state.pricingLevelGroupsMap);
  },
};
